import { LoaderIcon } from "@/assets/extra-icons";

export default function Loading() {
  return (
    <div class="mx-auto flex min-h-[100vh] max-w-xl items-center justify-center">
      <LoaderIcon class="h-20 w-20 animate-spin" />
    </div>
  );
}
